"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleIntegration = void 0;
const o11y_core_1 = require("@glovo/o11y-core");
const formatter = (0, o11y_core_1.sdkMessageFormatter)('CustomMetrics');
exports.consoleIntegration = {
    send({ name, type, value, tags, timestamp }) {
        console.groupCollapsed(...formatter('info', `metric: ${name}, type: ${type}, value: ${value}`));
        console.log('tags', tags);
        console.log('timestamp', timestamp);
        console.groupEnd();
    },
    clear() {
        // NOOP
    },
};
//# sourceMappingURL=index.js.map